var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppKarmaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3585 3.84533C11.5042 3.77051 11.6535 3.70256 11.8054 3.64124C12.3934 3.40403 13.0233 3.26986 13.6672 3.2517C13.863 3.24606 14.0599 3.25195 14.2574 3.26838C14.7401 3.30837 15.2253 3.4136 15.7015 3.59169C14.8145 3.19749 13.8522 2.93404 12.8347 2.83347C12.5231 2.80256 12.2133 2.7876 11.9065 2.7876C7.16213 2.7876 3.08698 6.39742 2.60987 11.2158C2.22083 15.1455 4.35959 18.9155 7.93212 20.5968C8.06851 20.6611 8.19238 20.7162 8.31037 20.7656C8.65943 20.911 9.03057 21.0386 9.41323 21.1443C11.2991 21.4975 13.1705 20.4533 13.8612 18.6597C14.2439 17.6664 14.2167 16.5837 13.785 15.6108C13.4023 14.7489 12.7422 14.0652 11.9057 13.6543C11.7983 13.6016 11.6881 13.5525 11.5751 13.5091C11.5397 13.4956 11.5054 13.4804 11.4708 13.4659C10.9233 13.2373 10.4516 12.9003 10.0721 12.4882C8.58094 11.0404 8.00473 8.79251 8.78699 6.72489C9.27758 5.42849 10.2154 4.43233 11.3585 3.84533Z",
    fill: "url(#paint0_radial_9647_2011)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.78675 6.72488C8.00449 8.79251 8.5807 11.0402 10.0719 12.4882C9.06885 11.4 8.70605 9.79529 9.27318 8.32325C10.0672 6.26176 12.3912 5.22856 14.4544 6.01989L14.4647 6.02406C16.4882 6.8051 18.0816 8.36618 18.925 10.3053C19.1707 10.8702 19.3532 11.467 19.4636 12.0864C19.4202 11.351 19.275 10.6337 19.0307 9.94001C18.8317 9.37485 18.5671 8.82538 18.2366 8.29455C17.6357 7.32881 17.0219 6.77124 16.954 6.71065C16.9525 6.70943 16.9508 6.70771 16.9488 6.70599L16.9449 6.70256C17.6626 7.24958 18.3208 7.94132 18.8676 8.8006C18.9694 8.96078 19.0638 9.12538 19.1523 9.29316C19.6866 10.306 19.9768 11.453 19.9949 12.6439C20.0156 14.0049 19.6837 15.366 19.0346 16.5803C17.9653 18.4516 16.3319 20.0164 14.6141 20.8303C17.972 19.5773 19.3736 17.2607 19.9155 15.9653C20.8952 13.4981 20.671 10.7863 19.3005 8.52513C19.2635 8.46405 19.2247 8.40444 19.1862 8.34435C17.383 5.53739 13.9989 4.04352 10.6925 4.61727C12.3603 4.28833 14.0666 4.44483 15.6362 5.12087C17.0614 5.73461 18.2671 6.71581 19.1541 7.97517C19.2657 8.13363 19.3729 8.29553 19.4739 8.46258C20.6474 10.3987 20.9796 12.707 20.4169 14.8877C21.0934 12.578 20.786 10.139 19.5296 8.06593C19.3756 7.81205 19.2105 7.56896 19.0358 7.33617C17.2012 4.89324 14.2738 3.64074 11.358 3.84507C10.2151 4.43232 9.27735 5.42848 8.78675 6.72488Z",
    fill: "url(#paint1_radial_9647_2011)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3646 5.7567C17.0633 4.45784 15.4188 3.60224 13.6684 3.25195C13.0247 3.27011 12.3945 3.40404 11.8066 3.64149C11.8066 3.64149 11.5711 3.74525 11.4359 3.80854C11.4104 3.82105 11.3846 3.83258 11.3594 3.84558C11.3594 3.84558 12.7196 3.53944 14.3618 3.92407C16.064 4.36635 17.6368 5.3105 18.8361 6.69791C19.1567 7.0688 19.452 7.46938 19.7143 7.90233C20.5122 9.21885 20.9545 10.7255 20.993 12.2591C21.0136 13.0902 20.917 13.9207 20.7087 14.7231C21.3793 12.3037 21.0452 9.66627 19.7258 7.48949C19.3355 6.84485 18.8761 6.26717 18.3646 5.7567Z",
    fill: "url(#paint2_radial_9647_2011)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0376 4.32122C16.6297 4.05286 16.1984 3.81639 15.7478 3.61304L15.7206 3.59808C15.7145 3.59587 15.7083 3.59391 15.7022 3.5917C15.6212 3.56128 15.54 3.53405 15.4586 3.50781C15.44 3.50192 15.4213 3.49579 15.4024 3.49014C15.3205 3.46488 15.2386 3.44108 15.1562 3.41999C15.1557 3.41999 15.1552 3.41974 15.1547 3.41974C15.0715 3.3984 14.9881 3.37976 14.9045 3.36234C14.8898 3.3594 14.8753 3.35621 14.8606 3.35327C14.7754 3.33634 14.6903 3.32138 14.6052 3.30862C14.4894 3.29145 14.3736 3.27796 14.2579 3.26839C14.0638 3.25245 13.8703 3.24681 13.6777 3.25171C13.7584 3.25196 14.3567 3.26619 15.2857 3.59268C16.2166 3.94468 17.0761 4.43749 17.837 5.05613C18.6517 5.71844 19.3544 6.52253 19.914 7.44583C20.6822 8.71329 21.1253 10.1017 21.2307 11.5727C21.2661 12.0655 21.2611 12.562 21.2172 13.0556C21.571 9.48059 19.8495 6.17126 17.0376 4.32122Z",
    fill: "url(#paint3_radial_9647_2011)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3572 3.84524C11.5029 3.77043 11.6523 3.70248 11.8041 3.64115C12.3921 3.40395 13.022 3.26977 13.6659 3.25162C13.8617 3.24598 14.0586 3.25186 14.2561 3.2683C14.7389 3.30828 15.2241 3.41351 15.7002 3.5916C15.1632 3.37059 14.613 3.23224 14.0633 3.16895C13.8384 3.14295 13.6137 3.12897 13.3897 3.12799C12.6538 3.1248 11.9292 3.25432 11.249 3.50354C11.0731 3.56805 10.9002 3.63993 10.7309 3.71989C9.40386 4.34786 8.29584 5.45048 7.6875 6.9127C6.71734 9.24501 7.29208 11.8332 8.94098 13.5419C9.35921 14.0264 9.88513 14.4289 10.5021 14.7103C10.5411 14.7282 10.5796 14.7466 10.6196 14.7635C10.7471 14.8175 10.871 14.8773 10.9917 14.9416C11.9317 15.4417 12.6602 16.2473 13.0649 17.2457C13.3698 17.998 13.466 18.7994 13.3561 19.5821C13.5602 19.3035 13.7307 18.9944 13.8597 18.6591C14.2424 17.6659 14.2151 16.5831 13.7834 15.6103C13.4008 14.7483 12.7407 14.0646 11.9042 13.6538C11.7967 13.601 11.6866 13.552 11.5735 13.5085C11.5382 13.4951 11.5039 13.4798 11.4693 13.4654C10.9218 13.2368 10.4501 12.8997 10.0706 12.4876C8.57941 11.0399 8.0032 8.79194 8.78546 6.72431C9.2763 5.4284 10.2141 4.43224 11.3572 3.84524Z",
    fill: "url(#paint4_radial_9647_2011)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_9647_2011",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.1183 -2.64046) scale(32.6069 32.6069)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2D236"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5503,
    stopColor: "#339959"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9656,
    stopColor: "#17594A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_9647_2011",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.2517 12.8773) scale(21.6279 21.6279)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2D236"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4868,
    stopColor: "#339959"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7465,
    stopColor: "#17594A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_9647_2011",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.1937 19.5341) scale(30.3535 30.3535)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2D236"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4868,
    stopColor: "#339959"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7011,
    stopColor: "#17594A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_9647_2011",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.1932 19.5341) scale(30.3535 30.3535)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B2D236"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4868,
    stopColor: "#339959"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7011,
    stopColor: "#17594A"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_9647_2011",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.1321 -7.86326) scale(38.465 38.465)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.3545,
    stopColor: "#B2D236"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5608,
    stopColor: "#339959"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5871,
    stopColor: "#309157"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7027,
    stopColor: "#227250"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8012,
    stopColor: "#1A604C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8704,
    stopColor: "#17594A"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppKarmaIcon);
export default __webpack_public_path__ + "static/media/AppKarmaIcon.ee4466fc117763352b7d02731801a990.svg";
export { ForwardRef as ReactComponent };